import { useApolloClient } from "@apollo/client";
import { makeStyles } from "@material-ui/core";
import Button from "@mostrans/web-components/components/base/Button";
import Checkbox from "@mostrans/web-components/components/base/Checkbox";
import Dropzone from "@mostrans/web-components/components/base/Dropzone";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import Radio from "@mostrans/web-components/components/base/Radio";
import Select from "@mostrans/web-components/components/base/Select";
import { useConfirmationModal } from "@mostrans/web-components/hooks/useConfirmationModal";
import {
  Box,
  CircularProgress,
  Container,
  Dialog,
  Grid,
  Icon,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { useSetState } from "react-use";
import { useRecoilState } from "recoil";
import { useGetdetailOpportunity } from "../../GQL/Opportunity/hooks/useGetdetailOpportunity";
import { createApplication } from "../../graphql/mutations";
import { isEmailExist, isPhoneExist } from "../../graphql/query";
import ModalPreviewApplication from "../../pages/Admin/Candidate/modals/ModalPreviewApplication/ModalPreviewApplication";
import { BLOB_TYPE, OPTION_SOURCE_INFORMATION } from "../../shared/constants";
import {
  URLtoFile,
  uploadCVCandidate,
  uploadImageCandidate
} from "../../shared/firebaseServices";
import {
  globalLoadingAtom,
  globalModalOpenAtom,
} from "../../shared/globalStates";
import {
  generateFileName,
  isImageFile,
  swalAlert,
  toastError,
  toastWarning,
} from "../../shared/helpers";
import Badge from "../General/Badge";
import HeaderImage from "../General/HeaderImage";
import Navbar from "../Home/Navbar";
import ModalCropImage from "../modals/ModalCropImage";
import "./Form.css";
import VerifyOTP from "./VerifyOTP";

const ApplicationForm = () => {
  let location = useLocation();
  const client = useApolloClient();
  const [OTP, setOTP] = useState(null);
  const [open, setOpen] = useRecoilState(globalModalOpenAtom);
  const history = useHistory();
  const [showExperience, setShowExperience] = useState(false);
  const [img, setImg] = useState(null);
  const [isCurrentEducation, setIsCurrentEducation] = useState(false);
  const [isCurrentExperience, setIsCurrentExperience] = useState(false);
  const [isFreshGraduate, setIsFreshGraduate] = useState(false);
  const [imgFile, setImgFile] = useState([]);
  const [pdfFile, setPdfFile] = useState([]);
  const [loading, setLoading] = useRecoilState(globalLoadingAtom);
  const { showConfirmationModal } = useConfirmationModal();
  const [invalidMessage, setInvalidMessage] = useState(
    "Only .pdf files are accepted!"
  );
  const [isEmpty, setIsEmpty] = useState(false);
  const [detailOpportunity,] = useGetdetailOpportunity(location?.state?.id)

  // modal preview application form
  const [openPreview, setOpenPreview] = useState(false);
  const handleClose = () => setOpenPreview(false);
  const [tempImg, setTempImg] = useState()

  const [openCrop, setOpenCrop] = useState(false)
  const handleCloseCrop = () => {
    setImg(null)
    setImgFile(null)
    setTempImg(null)
    setOpenCrop(false)
    setCroppedImage(null)
  }

  const [croppedImage, setCroppedImage] = useState(null)

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);


  const emailVal =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const phoneVal =
    /^((\+62 8\d{2}([ -])|08\d{2}([ -]?)|\+628\d{2})\d{4}(\3\4)\d{2,6})$/i;

  const [Experiences, setExperiences] = useSetState({
    experiences: {
      company: null,
      detail: null,
      end_date: null,
      job_position: null,
      start_date: null,
      is_current: false,
    },
  });


  const [address, setAddress] = useState({
    address: "",
    region: "",
    city: "",
    subdistrict: "",
    urbanvillage: "",
    postal: "",
    rt: "",
    rw: "",
  });
  const [values, setValues] = useSetState({
    link_photo: "",
    full_name: "",
    short_name: "",
    gender: "",
    birth_location: "",
    birth_date: "",
    email: "",
    phone_number: "",
    address: "",
    Education: {
      degree: "",
      major: "",
      ipk: "",
      start_year: "",
      graduate_year: "",
      school_name: "",
      is_current: false,
    },
    Experiences: [],
    link_cv: "",
    curr_salary: "",
    curr_benefits: [],
    expected_salary: "",
    expected_benefits: [],
  });

  const [info, setInfo] = useSetState({
    source_info: "",
  });

  const listPendidikan = ["SMA/SMK", "D1", "D2", "D3", "S1", "S2", "S3"];

  const years = function (startYear) {
    var currentYear = new Date().getFullYear(),
      years = [];
    startYear = startYear || 1950;
    while (startYear <= currentYear) {
      years.push(startYear++);
    }
    return years.reverse();
  };

  const avatarUrl =
    "https://images.vexels.com/media/users/3/129616/isolated/preview/fb517f8913bd99cd48ef00facb4a67c0-businessman-avatar-silhouette-by-vexels.png";

  const handleMinDOB = () => {
      let TODAY = new Date();
      let SIXTEEN_YEARS_BACK = new Date(TODAY.getFullYear() - 16, TODAY.getMonth(), TODAY.getDate());
    
      let USER_INPUT = new Date(values.birth_date);
      USER_INPUT.setHours(0, 0, 0, 0); 
      
      let result = SIXTEEN_YEARS_BACK >= USER_INPUT;
      return !result;
      // let TODAY = new Date(Date.now());
      // let SIXTEEN_YEARS_BACK = new Date(
      //   new Date(TODAY).getFullYear() -
      //   16 +
      //   "/" +
      //   new Date(TODAY).getMonth() +
      //   "/" +
      //   new Date(TODAY).getDate()
      // );
      // console.log(SIXTEEN_YEARS_BACK)
      // let USER_INPUT = new Date(values.birth_date);
      // let result = SIXTEEN_YEARS_BACK > USER_INPUT;
      // return !result;
  };

  const addExperiences = () => {
    setValues({
      Experiences: [...values.Experiences, Experiences.experiences],
    });
    setExperiences({
      experiences: {
        company: null,
        detail: null,
        end_date: null,
        job_position: null,
        start_date: null,
      },
    });
    setShowExperience(false);
  };

  const handleImage = (files) => {
    const isImage = isImageFile(files.target.files[0]);
    if (!isImage)
      return swalAlert({ text: "Wrong format file!", title: "Error" });
    setIsEmpty(false);
    setOpenCrop(true)
    setImgFile(files);
    setTempImg(URL.createObjectURL(files.target.files[0]));
    setImg(URL.createObjectURL(files.target.files[0]));
  };


  const handlePdf = (files) => {
    const isPdf = () => {
      return files.type === BLOB_TYPE.PDF;
    };
    if (!isPdf) return;
    setPdfFile(files);
  };

  const handleOpenPreviewApplication = () => {
    setOpenPreview(true);
  };

  const confirmationAlert = async () => {
    const show = await showConfirmationModal(
      {
        contentText: (
          <div>
            Check your data below! is the data correct?
            <p>Email : {values.email}</p>
            <p>Phone Number : {values.phone_number}</p>
          </div>
        ),
        modalProps: {},
      },
      // null,
      // null,
      // null,
      // 999999
    );

    //test

    if (show.isConfirmed) {
      setLoading(true);
      const image = await URLtoFile(imgFile);
      const imageName = generateFileName(
        "imageProfile-",
        image?.name
        // imgFile.target.files[0].name
      );

      values.link_photo = await uploadImageCandidate(image, imageName);
      const cv_name = generateFileName("resume-", pdfFile.name);
      values.link_cv = await uploadCVCandidate(pdfFile, cv_name);
      // const opportunity_id = parseInt(query.get("id"));
      const sourceInfo = info.source_info;
      if (values.link_cv && values.link_photo) {
        values.Education.ipk = parseFloat(values.Education.ipk);
        createApplication(client, values, location.state.id, sourceInfo).then(
          (result) => {
            if (result.status !== "000") {
              setLoading(false);
              toastError("Error, please try again later");
            } else {
              setLoading(false);
              setOTP(result.OTP);
              setOpen(true);
            }
          }
        );
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      imgFile.length === 0 ||
      !values.full_name ||
      !values.short_name ||
      !values.gender ||
      !values.birth_date ||
      handleMinDOB() ||
      !values.birth_location ||
      !values.email ||
      !values.email.match(emailVal) ||
      !values.phone_number ||
      !values.phone_number.match(phoneVal) ||
      !values.address ||
      !values.Education.start_year ||
      (!isCurrentEducation && !values.Education.graduate_year) ||
      !values.Education.major ||
      !values.Education.ipk ||
      !values.Education.school_name ||
      (values.Education.graduate_year &&
        values.Education.start_year > values.Education.graduate_year) ||
      // !values.Experiences.length === 0 ||
      !values.Education.degree ||
      !address.address ||
      !address.city ||
      !address.postal ||
      !address.region ||
      !address.rt ||
      !address.rw ||
      !address.subdistrict ||
      !address.urbanvillage ||
      showExperience ||
      (showExperience && !isCurrentExperience) ||
      pdfFile.length === 0 ||
      !values.curr_salary ||
      !values.expected_salary ||
      !values.curr_benefits.length ||
      !values.expected_benefits.length ||
      !info.source_info.length
    ) {
      setIsEmpty(true);
      toastError("Error, please input all requirements!");
    } else if (
      values.Experiences.length === 0 &&
      !isFreshGraduate &&
      (!Experiences.experiences.company ||
        !Experiences.experiences.job_position ||
        !Experiences.experiences.start_date ||
        !Experiences.experiences.detail ||
        !Experiences.experiences.end_date)
    ) {
      setIsEmpty(true);
      setShowExperience(true);
      toastError("Error, please input work experience requirements!");
    } else {
      setLoading(true);
      const checkEmail = await isEmailExist(client, values.email);
      const checkPhoneNum = await isPhoneExist(client, values.phone_number);
      if (checkEmail === true || checkPhoneNum === true) {
        toastWarning("Email or Phone number already exist, Please Login!");
        setLoading(false);
      } else {
        setLoading(false);
        // confirmationAlert();
        handleOpenPreviewApplication();
      }
    }
  };

  useEffect(() => {
    setValues({
      ...values,
      address: "".concat(
        address.address +
        ",RT " +
        address.rt +
        ",RW " +
        address.rw +
        "," +
        address.subdistrict +
        "," +
        address.urbanvillage +
        "," +
        address.city +
        "," +
        address.region +
        "," +
        address.postal
      ),
    });
  }, [address]);

  const handleChange = (e, name) => {
    e.preventDefault();
    if (name === "email") {
      return setValues({ ...values, [name]: e.target.value });
    }
    setValues({ ...values, [name]: e.target.value.toUpperCase() });
  };

  const useStyle = makeStyles({
    root: {
      "& .MuiFormControl-root": {
        margin: "15px 0",
      },
    },
  });
  const classes = useStyle();
  const handleIsCurrentEducation = () => {
    setIsCurrentEducation(!isCurrentEducation);
    setValues({
      Education: {
        ...values.Education,
        graduate_year: null,
        is_current: !isCurrentEducation,
      },
    });
  };
  const handleIsCurrentExperience = () => {
    setIsCurrentExperience(!isCurrentExperience);
    setExperiences({
      experiences: {
        ...Experiences.experiences,
        end_date: null,
        is_current: !isCurrentExperience,
      },
    });
  };

  const handleIsFreshGraduate = () => {
    setIsFreshGraduate(!isFreshGraduate);
    setShowExperience(false);
  };

  const handleSaveCrop = (value) => {
    setImg(value)
    setImgFile(value)
    setCroppedImage(null)
    setOpenCrop(false)
  }




  return !location?.state?.id ? (
    <Redirect to="/" />
  ) : (
    <React.Fragment>
      {/* <ConfirmationModal /> */}

      <Box
        sx={{
          position: "fixed !important",
          textAlign: "center !important",
          justifyContent: "center !important",
          top: "0 !important",
          bottom: " 0 !important",
          right: "0 !important",
          left: "0 !important",
          width: "100% !important",
          height: "100% !important",
          display: loading ? "flex !important" : "none !important",
          alignItems: "center !important",
          backgroundColor: "#00000087 !important",
          zIndex: " 99999",
        }}
      >
        <CircularProgress />
      </Box>
      <Dialog open={open} maxWidth="xs">
        <VerifyOTP otp={OTP} data={values} setData={setValues} />
      </Dialog>
      <Navbar />
      <Box className="bg-white mt-5">
        <HeaderImage>
          <div className="d-flex flex-column p-2 align-items-center justify-content-center">
            <h1 className="text-primary-main">{detailOpportunity?.data?.title}</h1>
            <div className="d-flex gap-1 align-items-center justify-content-center">
              <Badge>{detailOpportunity?.data?.Division?.division}</Badge>
              <b className="text-secondary">{detailOpportunity?.data?.job_level}</b>
              <div className="d-flex">
                <Icon>location_on</Icon>
                <b className="text-secondary">
                  {detailOpportunity?.data?.Location?.nama}
                </b>
              </div>
            </div>
          </div>
        </HeaderImage>
        <Container maxWidth="md">
          <form className={classes.root} onSubmit={handleSubmit}>
            <Grid item xs={12} p={1}>
              {/* <h1 style={{ textAlign: "center", padding: "25px" }}>
                Application Form Mostrans Career
              </h1> */}
              <div
                className="self-identity"
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  borderRadius: "10px",
                  padding: "20px",
                  margin: "10px 0",
                }}
              >
                <div
                  className="wrapper"
                  style={{
                    display: "grid",
                    justifyContent: "center",
                  }}
                >
                  <div className="profile-image d-flex justify-content-center" style={{ border: "1px solid rgba(0, 0, 0, 0.20)" }}>
                    <label>
                      <Input
                        id="image"
                        name="image"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleImage}
                      />
                      <img
                        src={img !== null ? img : avatarUrl}
                        alt=""
                        width={"125px"}
                        className="img-avatar"
                      />
                      <div className="overlay text-neutral-n10 font-weight-w500">
                        <span className="image_icon material-icons text-neutral-n10">
                          edit
                        </span>
                        <span className="image_text">Change photo</span>
                      </div>
                    </label>
                  </div>
                  {
                    img && (
                      <Button
                        startIcon={<Icon>crop</Icon>}
                        onClick={() => { setOpenCrop(true); setImg(tempImg) }}
                      >Adjust
                      </Button>
                    )
                  }
                  <ModalCropImage
                    open={openCrop}
                    onClose={handleCloseCrop}
                    onSaveCrop={handleSaveCrop}
                    croppedImage={croppedImage}
                    setCroppedImage={setCroppedImage}
                    dataImg={img}
                  />
                  {!img && isEmpty && (
                    <span className="text-danger-main font-size-main text-center my-1">
                      Please upload your photo!
                    </span>
                  )}
                </div>
                <h5 className="text-primary-main" style={{ margin: "20px 0" }}>I. BASIC INFORMATION</h5>
                <div className="form font-size-main row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <FormGroup
                      className="input_fullname"
                      label="Full Name"
                      errorMessage={"Full name cannot be empty!"}
                      isError={isEmpty && !values.full_name}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="fullname"
                        name="fullname"
                        maxLength={30}
                        onChange={(e) => handleChange(e, "full_name")}
                        type="text"
                        placeholder="Enter full name"
                        style={{ textTransform: "uppercase" }}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <FormGroup
                      className="input_shortname"
                      label="Short Name"
                      errorMessage={"Short name cannot be empty!"}
                      isError={isEmpty && !values.short_name}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="shortname"
                        name="shortname"
                        onChange={(e) => handleChange(e, "short_name")}
                        type="text"
                        maxLength={20}
                        placeholder="Enter shortname"
                        style={{ textTransform: "uppercase" }}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <FormGroup
                      className="input_gender d-inline-flex"
                      label="Gender"
                      errorMessage={"Please select gender!"}
                      isError={isEmpty && !values.gender}
                      isRequired
                      style={{ padding: "10px 0" }}
                    >
                      <div className="d-inline-flex">
                        <label
                          htmlFor="male"
                          style={{
                            margin: "0 10px 0 0",
                          }}
                        >
                          <Radio
                            id="male"
                            name="gender"
                            checked={values.gender === "M"}
                            onChange={() => {
                              setValues({
                                gender: "M",
                              });
                            }}
                          />
                          Male
                        </label>
                        <label
                          htmlFor="female"
                          style={{
                            margin: "0 10px 0 0",
                          }}
                        >
                          <Radio
                            id="female"
                            name="gender"
                            checked={values.gender === "F"}
                            onChange={() => {
                              setValues({
                                gender: "F",
                              });
                            }}
                          />
                          Female
                        </label>
                      </div>
                    </FormGroup>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <FormGroup
                      className="input_pob"
                      label="Place of Birth"
                      errorMessage={"Place of Birth cannot be empty!"}
                      isError={isEmpty && !values.birth_location}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="pob"
                        name="pob"
                        maxLength={50}
                        onChange={(e) => handleChange(e, "birth_location")}
                        type="text"
                        placeholder="Enter place of birth"
                        style={{ textTransform: "uppercase" }}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <FormGroup
                      className="input_dob"
                      label="Date of Birth"
                      errorMessage={
                        isEmpty && !values.birth_date
                          ? "Date of Birth cannot be empty!"
                          : handleMinDOB()
                            ? "Date of birth must be above 16 years"
                            : ""
                      }
                      isError={Boolean(
                        (isEmpty && !values.birth_date) ||
                        (handleMinDOB() && values.birth_date)
                      )}
                      showChildErrorSign
                      isRequired
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="dob"
                        name="dob"
                        onChange={(e) => {
                          handleChange(e, "birth_date");
                          handleMinDOB();
                        }}
                        type="date"
                        style={{ textTransform: "uppercase" }}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <FormGroup
                      className="input_email"
                      label="Email"
                      errorMessage={
                        isEmpty && !values.email
                          ? "Email cannot be empty!"
                          : !values.email.match(emailVal)
                            ? "Email not valid"
                            : ""
                      }
                      isError={Boolean(
                        (isEmpty && !values.email) ||
                        (!values.email.match(emailVal) && values.email)
                      )}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="email"
                        name="email"
                        onChange={(e) => handleChange(e, "email")}
                        type="text"
                        placeholder="Enter email"
                        maxLength={50}
                        style={{ textTransform: "lowercase" }}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <FormGroup
                      className="input_phone"
                      label="Phone Number"
                      errorMessage={
                        isEmpty && !values.phone_number
                          ? "Phone Number cannot be empty!"
                          : !values.phone_number.match(phoneVal)
                            ? "Phone Number not valid, Format must start with 08xx and be at least 8 characters long"
                            : ""
                      }
                      isError={Boolean(
                        (isEmpty && !values.phone_number) ||
                        (!values.phone_number.match(phoneVal) &&
                          values.phone_number)
                      )}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="phone"
                        name="phone"
                        onChange={(e) => handleChange(e, "phone_number")}
                        type="number"
                        placeholder="Ex: 0812xxxx"
                        maxLength={12}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <FormGroup
                      className="input_address"
                      label="Address"
                      errorMessage={"Address cannot be empty!"}
                      isError={isEmpty && !address.address}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="address"
                        name="address"
                        onChange={(e) =>
                          setAddress({
                            ...address,
                            address: e.target.value.toUpperCase(),
                          })
                        }
                        type="text"
                        maxLength={50}
                        placeholder="Enter address"
                        style={{ textTransform: "uppercase" }}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                    <FormGroup
                      className="input_city"
                      label="Province"
                      errorMessage={"Region cannot be empty!"}
                      isError={isEmpty && !address.region}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="Region"
                        name="Region"
                        onChange={(e) =>
                          setAddress({
                            ...address,
                            region: e.target.value.toUpperCase(),
                          })
                        }
                        type="text"
                        maxLength={20}
                        placeholder="Enter Region"
                        style={{ textTransform: "uppercase" }}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                    <FormGroup
                      className="input_city"
                      label="City"
                      errorMessage={"City cannot be empty!"}
                      isError={isEmpty && !address.city}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="city"
                        name="city"
                        onChange={(e) =>
                          setAddress({
                            ...address,
                            city: e.target.value.toUpperCase(),
                          })
                        }
                        type="text"
                        maxLength={20}
                        placeholder="Enter city"
                        style={{ textTransform: "uppercase" }}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                    <FormGroup
                      className="input_subdistrict"
                      label="Sub-district"
                      errorMessage={"Sub-district cannot be empty!"}
                      isError={isEmpty && !address.subdistrict}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="subdistrict"
                        name="subdistrict"
                        onChange={(e) =>
                          setAddress({
                            ...address,
                            subdistrict: e.target.value.toUpperCase(),
                          })
                        }
                        type="text"
                        maxLength={20}
                        placeholder="Enter Sub-district"
                        style={{ textTransform: "uppercase" }}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                    <FormGroup
                      className="input_urbanvillage"
                      label="Urban village"
                      errorMessage={"Urban village cannot be empty!"}
                      isError={isEmpty && !address.urbanvillage}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="urbanvillage"
                        name="urbanvillage"
                        onChange={(e) =>
                          setAddress({
                            ...address,
                            urbanvillage: e.target.value.toUpperCase(),
                          })
                        }
                        type="text"
                        maxLength={20}
                        placeholder="Enter Urban village"
                        style={{ textTransform: "uppercase" }}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                    <FormGroup
                      className="input_postalcode"
                      label="Postal Code"
                      errorMessage={"Postal Code cannot be empty!"}
                      isError={isEmpty && !address.postal}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="Postal_Code"
                        name="Postal_Code"
                        value={!address.postal ? "" : address.postal}
                        onChange={(e) => {
                          const regex = /^[0-9]+$/;
                          if (
                            e.target.value === "" ||
                            regex.test(e.target.value)
                          ) {
                            setAddress({
                              ...address,
                              postal: e.target.value,
                            });
                          }
                        }}
                        type="text"
                        maxLength={6}
                        placeholder="Enter Postal Code"
                        style={{ textTransform: "uppercase" }}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-2 col-xs-4">
                    <FormGroup
                      className="input_rt"
                      label="RT"
                      errorMessage={"RT cannot be empty!"}
                      isError={isEmpty && !address.rt}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="rt"
                        name="rt"
                        value={!address.rt ? "" : address.rt}
                        onChange={(e) => {
                          const regex = /^[0-9]+$/;
                          if (
                            e.target.value === "" ||
                            regex.test(e.target.value)
                          ) {
                            setAddress({
                              ...address,
                              rt: e.target.value,
                            });
                          }
                        }}
                        type="text"
                        maxLength={3}
                        placeholder="Enter RT"
                        style={{ textTransform: "uppercase" }}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-2 col-xs-4">
                    <FormGroup
                      className="input_rw"
                      label="RW"
                      errorMessage={"RW cannot be empty!"}
                      isError={isEmpty && !address.rw}
                      isRequired
                      showChildErrorSign
                      style={{ padding: "10px 0" }}
                    >
                      <Input
                        id="rw"
                        name="rw"
                        value={!address.rw ? "" : address.rw}
                        onChange={(e) => {
                          const regex = /^[0-9]+$/;
                          if (
                            e.target.value === "" ||
                            regex.test(e.target.value)
                          ) {
                            setAddress({
                              ...address,
                              rw: e.target.value,
                            });
                          }
                        }}
                        type="text"
                        maxLength={3}
                        placeholder="Enter RW"
                        style={{ textTransform: "uppercase" }}
                      />
                    </FormGroup>
                  </div>
                </div>
              </div>
              <div
                className="last-education"
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  borderRadius: "10px",
                  padding: "20px",
                  margin: "10px 0",
                }}
              >
                <h5 className="text-primary-main" style={{ margin: "20px 0" }}>II. EDUCATIONAL INFORMATION</h5>
                <div className="form font-size-main">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup
                        className="my-1"
                        label="Level"
                        errorMessage={"Qualification cannot be empty"}
                        isError={isEmpty && !values.Education.degree}
                        isRequired
                        showChildErrorSign
                      >
                        <Select
                          id="qualification"
                          name="qualification"
                          onChange={(e) =>
                            setValues({
                              Education: {
                                ...values.Education,
                                degree: e.value.toUpperCase(),
                              },
                            })
                          }
                          getOptionLabel={(option) => option.label}
                          getOptionValue={(option) => option.value}
                          options={listPendidikan.map((value) => ({
                            value: value,
                            label: value,
                          }))}
                        />
                      </FormGroup>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup
                        className="my-1"
                        label="Name of University/School"
                        errorMessage={
                          "Name of University/School cannot be empty"
                        }
                        isError={isEmpty && !values.Education.school_name}
                        isRequired
                        showChildErrorSign
                      >
                        <Input
                          id="nameofEducation"
                          name="nameofEducation"
                          onChange={(e) =>
                            setValues({
                              Education: {
                                ...values.Education,
                                school_name: e.target.value.toUpperCase(),
                              },
                            })
                          }
                          maxLength={50}
                          type="text"
                          placeholder="Name of University/School"
                          style={{ textTransform: "uppercase" }}
                        />
                      </FormGroup>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-8">
                      <FormGroup
                        className="my-1"
                        label="Major"
                        errorMessage={"Major cannot be empty"}
                        isError={isEmpty && !values.Education.major}
                        isRequired
                        showChildErrorSign
                      >
                        <Input
                          id="Jurusan"
                          name="Jurusan"
                          onChange={(e) =>
                            setValues({
                              Education: {
                                ...values.Education,
                                major: e.target.value.toUpperCase(),
                              },
                            })
                          }
                          maxLength={50}
                          type="text"
                          placeholder="Enter Major"
                          style={{ textTransform: "uppercase" }}
                        />
                      </FormGroup>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-4">
                      <FormGroup
                        className="my-1"
                        label="IPK/Grade"
                        errorMessage={
                          values.Education.ipk?.length > 5
                            ? "IPK/Grade too long"
                            : "IPK/Grade cannot be empty"
                        }
                        isError={
                          (isEmpty && !values.Education.ipk) ||
                          values.Education.ipk?.length > 5
                        }
                        isRequired
                        showChildErrorSign
                      >
                        <Input
                          id="ipk"
                          name="ipk"
                          onChange={(e) => {
                            const regex = /^[0-9\d.]+$/;
                            if (
                              e.target.value === "" ||
                              regex.test(e.target.value)
                            ) {
                              setValues({
                                Education: {
                                  ...values.Education,
                                  ipk: e.target.value,
                                },
                              });
                            }
                          }}
                          value={values.Education.ipk}
                          type="number"
                          placeholder="Enter IPK"
                        />
                      </FormGroup>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                          <FormGroup
                            className="my-1"
                            label="Start Year"
                            errorMessage={"Start year cannot be empty"}
                            isError={isEmpty && !values.Education.start_year}
                            isRequired
                            showChildErrorSign
                          >
                            <Select
                              id="start_year"
                              name="start_year"
                              getOptionLabel={(option) => option.label}
                              getOptionValue={(option) => option.value}
                              onChange={(e) =>
                                setValues({
                                  Education: {
                                    ...values.Education,
                                    start_year: e.value,
                                  },
                                })
                              }
                              options={years().map((value) => ({
                                value: value,
                                label: value,
                              }))}
                            />
                          </FormGroup>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                          <FormGroup
                            className="my-1"
                            label="End Year"
                            errorMessage={
                              isEmpty &&
                                !isCurrentEducation &&
                                !values.Education.graduate_year
                                ? "End year cannot be empty"
                                : values.Education.graduate_year &&
                                values.Education.start_year >
                                values.Education.graduate_year &&
                                "End year cannot be earlier than start year"
                            }
                            isError={
                              (isEmpty &&
                                !isCurrentEducation &&
                                !values.Education.graduate_year) ||
                              Boolean(
                                values.Education.graduate_year &&
                                values.Education.start_year >
                                values.Education.graduate_year
                              )
                            }
                            isRequired
                            showChildErrorSign
                          >
                            <Select
                              id="end_year"
                              name="end_year"
                              isDisabled={isCurrentEducation}
                              getOptionLabel={(option) => option.label}
                              getOptionValue={(option) => option.value}
                              onChange={(e) =>
                                setValues({
                                  Education: {
                                    ...values.Education,
                                    graduate_year: e.value,
                                  },
                                })
                              }
                              options={years().map((value) => ({
                                value: value,
                                label: value,
                              }))}
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <FormGroup
                        className="justify-content-end"
                        placement="horizontal"
                        label="Currently I'm still studying here"
                      >
                        <Checkbox
                          checked={isCurrentEducation}
                          onClick={() => handleIsCurrentEducation()}
                        />
                      </FormGroup>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="addtional__info"
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  borderRadius: "10px",
                  padding: "20px",
                  margin: "10px 0",
                }}
              >
                <h5 className="text-primary-main" style={{ margin: "20px 0" }}>
                  III. Additional Information
                </h5>
                <div className="form font-size-main">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup
                        className="my-1"
                        label="Current Salary"
                        errorMessage={"Current Salary cannot be empty"}
                        isError={isEmpty && !values.curr_salary}
                        isRequired
                        showChildErrorSign
                      >
                        <Input
                          id="curr_salary"
                          name="curr_salary"
                          onChange={(e) =>
                            setValues({
                              ...values,
                              curr_salary: +e.target.value,
                            })
                          }
                          value={values.curr_salary}
                          type="currency"
                          placeholder="Current Salary"
                          style={{ textTransform: "uppercase" }}
                        />
                      </FormGroup>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup
                        className="my-1"
                        label="Current Benefits"
                        errorMessage={"Current Benefits cannot be empty"}
                        isError={isEmpty && !values.curr_benefits.length}
                        isRequired
                        showChildErrorSign
                      >
                        <Input
                          id="curr_benefits"
                          name="curr_benefits"
                          onChange={(e) =>
                            setValues({
                              ...values,
                              curr_benefits: e.target.value
                                .toUpperCase()
                                .split("\n"),
                            })
                          }
                          value={values.curr_benefits
                            ?.join()
                            .replaceAll(",", "\n")}
                          type="text"
                          multiline
                          placeholder="Current Benefits"
                          style={{ textTransform: "uppercase" }}
                        />
                      </FormGroup>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup
                        className="my-1"
                        label="Expected Salary"
                        errorMessage={"Expected Salary cannot be empty"}
                        isError={isEmpty && !values.expected_salary}
                        isRequired
                        showChildErrorSign
                      >
                        <Input
                          id="expected_salary"
                          name="expected_salary"
                          onChange={(e) =>
                            setValues({
                              ...values,
                              expected_salary: +e.target.value,
                            })
                          }
                          value={values.expected_salary}
                          type="currency"
                          placeholder="Expected Salary"
                          style={{ textTransform: "uppercase" }}
                        />
                      </FormGroup>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <FormGroup
                        className="my-1"
                        label="Expected Benefits"
                        errorMessage={"Expected Benefits cannot be empty"}
                        isError={isEmpty && !values.expected_benefits.length}
                        isRequired
                        showChildErrorSign
                      >
                        <Input
                          id="expected_benefits"
                          name="expected_benefits"
                          onChange={(e) =>
                            setValues({
                              ...values,
                              expected_benefits: e.target.value
                                .toUpperCase()
                                .split("\n"),
                            })
                          }
                          value={values.expected_benefits
                            ?.join()
                            .replaceAll(",", "\n")}
                          type="text"
                          multiline
                          placeholder="Expected Benefits"
                          style={{ textTransform: "uppercase" }}
                        />
                      </FormGroup>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="experience"
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  borderRadius: "10px",
                  padding: "20px",
                  margin: "10px 0",
                }}
              >
                <div className="column">
                  <div
                    style={{
                      marginTop: "20px",
                    }}
                  >
                    <h4>IV. WORK EXPERIENCE</h4>
                  </div>
                  <div
                    style={{
                      fontSize: "medium",
                      marginBottom: "15px",
                    }}
                  >
                    <FormGroup
                      className="justify-content-end"
                      placement="horizontal"
                      label="I'm a freshgraduate/undergraduate"
                    >
                      <Checkbox
                        checked={isFreshGraduate}
                        onClick={() => handleIsFreshGraduate()}
                      />
                    </FormGroup>
                    <small><b>Jika memiliki pengalaman internship, silahkan untuk dicantumkan.</b></small>
                  </div>
                </div>
                {values.Experiences.length >= 0 &&
                  values.Experiences.map((result, index) => (
                    <div
                      className="experiences__list font-size-h5 "
                      key={index}
                      style={{
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                        borderRadius: "10px",
                        padding: "20px",
                        margin: "10px 0",
                      }}
                    >
                      <div className="header__experiences d-flex font-weight-w500">
                        <div className="d-flex justify-content-between w-100">
                          <div className="title__experiences">{`${result.company} - ${result.job_position}`}</div>
                          <div className="date__experiences">{`${result.start_date
                            } - ${result.end_date ? result.end_date : "Present"
                            }`}</div>
                        </div>
                        <div
                          className="delete"
                          onClick={() =>
                            setValues({
                              Experiences: [
                                ...values.Experiences.slice(0, index),
                                ...values.Experiences.slice(
                                  index + 1,
                                  values.Experiences.length
                                ),
                              ],
                            })
                          }
                          style={{
                            paddingLeft: "20px",
                            cursor: "pointer",
                          }}
                        >
                          <span className="material-icons text-primary-main">
                            delete
                          </span>
                        </div>
                      </div>
                      <div className="detail__experiences font-size-main">
                        <p>{result.detail}</p>
                      </div>
                    </div>
                  ))}
                {showExperience ? (
                  <div className="form font-size-main">
                    <div className="row ">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup
                          className="my-1"
                          label="Company Name"
                          errorMessage={"Company name cannot be empty!"}
                          isRequired={!isFreshGraduate}
                          showChildErrorSign={!isFreshGraduate}
                          isError={
                            !isFreshGraduate
                              ? isEmpty && !Experiences.experiences.company
                              : !isFreshGraduate
                          }
                        >
                          <Input
                            id="company"
                            name="company"
                            onChange={(e) =>
                              setExperiences({
                                experiences: {
                                  ...Experiences.experiences,
                                  company: e.target.value.toUpperCase(),
                                },
                              })
                            }
                            maxLength={50}
                            type="text"
                            placeholder="Company Name"
                            style={{ textTransform: "uppercase" }}
                          />
                        </FormGroup>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup
                          className="my-1"
                          label="Position"
                          errorMessage={"Position cannot be empty!"}
                          isRequired={!isFreshGraduate}
                          showChildErrorSign={!isFreshGraduate}
                          isError={
                            !isFreshGraduate
                              ? isEmpty && !Experiences.experiences.job_position
                              : !isFreshGraduate
                          }
                        >
                          <Input
                            id="position"
                            type="text"
                            maxLength={50}
                            onChange={(e) =>
                              setExperiences({
                                experiences: {
                                  ...Experiences.experiences,
                                  job_position: e.target.value.toUpperCase(),
                                },
                              })
                            }
                            placeholder="Position"
                            style={{ textTransform: "uppercase" }}
                          />
                        </FormGroup>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup
                          className="my-1"
                          label="Start Date"
                          errorMessage={"Start Date cannot be empty!"}
                          isRequired={!isFreshGraduate}
                          showChildErrorSign={!isFreshGraduate}
                          isError={
                            !isFreshGraduate
                              ? isEmpty && !Experiences.experiences.start_date
                              : !isFreshGraduate
                          }
                        >
                          <Input
                            id="tahunMasuk-kerja"
                            onChange={(e) =>
                              setExperiences({
                                experiences: {
                                  ...Experiences.experiences,
                                  start_date: e.target.value,
                                },
                              })
                            }
                            type="date"
                            style={{ textTransform: "uppercase" }}
                          />
                        </FormGroup>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <FormGroup
                          className="my-1"
                          label="End Date"
                          errorMessage={
                            isEmpty && !Experiences.experiences.end_date
                              ? "End date cannot be empty!"
                              : Experiences.experiences.end_date &&
                              Experiences.experiences.start_date >
                              Experiences.experiences.end_date &&
                              "End date cannot be earlier than start date"
                          }
                          isError={
                            !isFreshGraduate
                              ? (isEmpty && !values.Experiences.end_date) ||
                              Boolean(
                                Experiences.experiences.end_date &&
                                Experiences.experiences.start_date >
                                Experiences.experiences.end_date
                              )
                              : !isFreshGraduate
                          }
                        >
                          <Input
                            id="tahunKeluar-kerja"
                            onChange={(e) =>
                              setExperiences({
                                experiences: {
                                  ...Experiences.experiences,
                                  end_date: e.target.value,
                                },
                              })
                            }
                            value={
                              Experiences.experiences.end_date
                                ? Experiences.experiences.end_date
                                : ""
                            }
                            type="date"
                            disabled={isCurrentExperience}
                            style={{ textTransform: "uppercase" }}
                          />
                        </FormGroup>
                        <FormGroup
                          className="justify-content-end"
                          placement="horizontal"
                          label="I'm currently working in this company"
                        >
                          <Checkbox
                            checked={isCurrentExperience}
                            onClick={() => handleIsCurrentExperience()}
                          />
                        </FormGroup>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <FormGroup
                          className="my-1"
                          label="Job Desc"
                          errorMessage={"Job Description cannot be empty!"}
                          isRequired={!isFreshGraduate}
                          showChildErrorSign={!isFreshGraduate}
                          isError={
                            !isFreshGraduate
                              ? isEmpty && !Experiences.experiences.detail
                              : !isFreshGraduate
                          }
                        >
                          <Input
                            id="details"
                            multiline
                            maxLength={255}
                            onChange={(e) =>
                              setExperiences({
                                experiences: {
                                  ...Experiences.experiences,
                                  detail: e.target.value.toUpperCase(),
                                },
                              })
                            }
                            type="text"
                            placeholder="Job Desc"
                            style={{ textTransform: "uppercase" }}
                          />
                        </FormGroup>
                      </div>
                      <div className="error m-auto">
                        {isEmpty && showExperience && (
                          <span className="text-danger-main">
                            Save your work experience!
                          </span>
                        )}
                      </div>
                    </div>
                    <Box textAlign="center">
                      <Button
                        style={{
                          margin: "10px",
                          width: "25%",
                          height: "3rem",
                        }}
                        variant="outlined"
                        color="danger"
                        onClick={() => setShowExperience(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        style={{
                          margin: "10px",
                          width: "25%",
                          height: "3rem",
                        }}
                        variant="contained"
                        color="primary"
                        onClick={() => addExperiences()}
                        disabled={
                          !Experiences.experiences.company ||
                            !Experiences.experiences.detail ||
                            (!isCurrentExperience &&
                              !Experiences.experiences.end_date) ||
                            (Experiences.experiences.end_date &&
                              Experiences.experiences.start_date >
                              Experiences.experiences.end_date) ||
                            !Experiences.experiences.job_position ||
                            !Experiences.experiences.start_date
                            ? true
                            : false
                        }
                      >
                        Save
                      </Button>
                    </Box>
                  </div>
                ) : null}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setShowExperience(true)}
                >
                  <span className="material-icons"> add </span>
                </Button>
              </div>

              {/* -------------select source information------------ */}
              <div
                className="sourceInfo"
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  borderRadius: "10px",
                  padding: "20px",
                  margin: "10px 0",
                }}
              >
                <div
                  style={{
                    marginTop: "20px",
                    marginBottom: "15px",
                  }}
                  className="form font-size-main"
                >
                  <FormGroup
                    label="Source Information"
                    isRequired
                    errorMessage={"Source Information cannot be empty"}
                    showChildErrorSign
                    isError={isEmpty && !info.source_info}
                  >
                    <Select
                      id="sourceinfo"
                      name="sourceinfo"
                      onChange={(e) => {
                        setInfo({
                          ...info,
                          source_info: e.value,
                        });
                      }}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      options={OPTION_SOURCE_INFORMATION.map((value) => ({
                        value: value.value,
                        label: value.label,
                      }))}
                    />
                  </FormGroup>
                </div>
              </div>

              <div className="resumes">
                <FormGroup
                  style={{
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                >
                  <Dropzone
                    id="resume"
                    name="resume"
                    onChange={(e) => handlePdf(e[0])}
                    accept=".pdf"
                    middleText={
                      pdfFile.name ? pdfFile.name : "CLICK/DRAG YOUR FILE HERE"
                    }
                    topText={"Upload Your CV!"}
                    bottomText={invalidMessage}
                    onInvalid={(invalidMessage) => {
                      setInvalidMessage(invalidMessage);
                      swalAlert({ title: "Error", text: invalidMessage });
                    }}
                  />
                  {isEmpty && pdfFile.length === 0 && (
                    <span className="text-danger-main">Upload your CV!</span>
                  )}
                </FormGroup>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  onClick={() => history.goBack()}
                  className="m-2 w-25"
                  variant="outlined"
                  color="danger"
                >
                  Cancel
                </Button>
                <Button
                  className="m-2 w-25"
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  Apply
                </Button>
              </div>
            </Grid>
          </form>
        </Container>
      </Box>
      {openPreview && (
        <>
          <Dialog
            open={openPreview}
            fullWidth={true}
            maxWidth="md"
            style={{ zIndex: "90" }}
          >
            <ModalPreviewApplication
              data={values}
              confirmationAlert={confirmationAlert}
              onClose={handleClose}
              img={img}
            />
          </Dialog>
        </>
      )}
    </React.Fragment>
  );
};

export default ApplicationForm;
